import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import ProjectsSelect from "../projects/ProjectsSelect";
import { DelayInput } from "react-delay-input/lib/Component";
import DatePicker from "../datePicker/DatePicker";
import PaymentTypeSelect from "./PaymentTypeSelect";
import SecondaryTransactionTypeSelect from "./SecondaryTransactionTypeSelect";
import TransactionStatusSelect from "./TransactionStatusSelect";
import TransactionTypeSelect from "./TransactionTypeSelect";
import MappedServicesFilter from "../serviceReletionships/mappedServices/MappedServicesFilter";
import {
  firstDayOfMonth,
  getEndOfDayFromDate,
  getStartOfDayFromDate,
  lastDayOfMonth,
  TimestampToDate
} from "../../../utils/timestampToDate";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../filter/styledFiter";
import { StyledDatepicker } from "../../styles/styledDatepicker";
import { StyledTooltip } from "../../styles/styledTooltip";
import { Tooltip } from "@material-ui/core";

const TransactionFilter = ({
  filterData,
  setFilterData,
  userId,
  removableCreatedAt = true,
  showUserEmail = false,
  direction = null
}) => {
  const { t } = useTranslation("cashFlow");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"] ?? null,
    "id": "",
    "referenceId": "",
    "relatedReferenceId": "",
    "processingId": "",
    "exchangeId": "",
    "hash": "",
    "note": "",
    "connection.project.name": null,
    "connection.service.name": null,
    "connection.project.user.email": null,
    "paymentSystem.name": null,
    "currency.asset": null,
    "resourceType": null,
    "paymentType": null,
    "transactionType": null,
    "status.value": null,
    "processedAmount[gte]": "",
    "processedAmount[lte]": "",
    "createdAt[gte]": null,
    "createdAt[lte]": null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {

    if (filterData["currentTab"]) {
      DEFAULT_FILTER_DATA.currentTab = filterData["currentTab"];
    }

    if (!removableCreatedAt) {
      DEFAULT_FILTER_DATA["createdAt[gte]"] = firstDayOfMonth();
      DEFAULT_FILTER_DATA["createdAt[lte]"] = lastDayOfMonth();
    }

    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("transactions.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("transactions.filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock>
            <StyledFilterGroup>
              <label htmlFor="id">
                Id
                <Tooltip
                  title={t("transactions.filter.tooltips.id")}
                  arrow
                  placement="top"
                >
                  <StyledTooltip className="icon-light-help" />
                </Tooltip>
              </label>
              <DelayInput
                id="id"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "id": event.target.value, page: 1 })}
                name="id"
                value={filterData["id"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="referenceId">
                Reference Id
                <Tooltip
                  title={t("transactions.filter.tooltips.referenceId")}
                  arrow
                  placement="top"
                >
                  <StyledTooltip className="icon-light-help" />
                </Tooltip>
              </label>
              <DelayInput
                id="referenceId"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "referenceId": event.target.value, page: 1 })}
                name="referenceId"
                value={filterData["referenceId"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="processingId">
                Processing Id
                <Tooltip
                  title={t("transactions.filter.tooltips.processingId")}
                  arrow
                  placement="top"
                >
                  <StyledTooltip className="icon-light-help" />
                </Tooltip>
              </label>
              <DelayInput
                id="processingId"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "processingId": event.target.value, page: 1 })}
                name="processingId"
                value={filterData["processingId"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="exchangeId">
                Exchange Id
                <Tooltip
                  title={t("transactions.filter.tooltips.exchangeId")}
                  arrow
                  placement="top"
                >
                  <StyledTooltip className="icon-light-help" />
                </Tooltip>
              </label>
              <DelayInput
                id="exchangeId"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "exchangeId": event.target.value, page: 1 })}
                name="exchangeId"
                value={filterData["exchangeId"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="hash">
                Hash
                <Tooltip
                  title={t("transactions.filter.tooltips.hash")}
                  arrow
                  placement="top"
                >
                  <StyledTooltip className="icon-light-help" />
                </Tooltip>
              </label>
              <DelayInput
                id="hash"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "hash": event.target.value, page: 1 })}
                name="hash"
                value={filterData["hash"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="note">
                {t("transactions.filter.note")}
              </label>
              <DelayInput
                id="note"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "note": event.target.value, page: 1 })}
                name="note"
                value={filterData["note"]}
                type="text"
              />
            </StyledFilterGroup>
            {showUserEmail && (
              <>
                <StyledFilterGroup>
                  <label htmlFor="connection.project.user.email">
                    {t("transactions.filter.user")}
                  </label>
                  <DelayInput
                    id="connection.project.user.email"
                    delayTimeout={2000}
                    onChange={event => setFilterData({
                      ...filterData,
                      "connection.project.user.email": event.target.value,
                      page: 1
                    })}
                    name="connection.project.user.email"
                    value={filterData["connection.project.user.email"]}
                    type="text"
                    placeholder={t("transactions.filter.userPlaceholder")}
                  />
                </StyledFilterGroup>

                <StyledFilterGroup>
                  <label htmlFor="connection.project.user.nickname">
                    {t("transactions.filter.nickname")}
                  </label>
                  <DelayInput
                    id="connection.project.user.nickname"
                    delayTimeout={2000}
                    onChange={event => setFilterData({
                      ...filterData,
                      "connection.project.user.nickname": event.target.value,
                      page: 1
                    })}
                    name="connection.project.user.nickname"
                    value={filterData["connection.project.user.nickname"]}
                    type="text"
                    placeholder={t("transactions.filter.nicknamePlaceholder")}
                  />
                </StyledFilterGroup>
              </>
            )}
            <StyledSelectGroup>
              <ProjectsSelect
                checkedProjects={filterData["connection.project.name"]}
                setCheckedProjects={(data) => setFilterData({
                  ...filterData,
                  "connection.project.name": data,
                  page: 1
                })}
                isObject={false}
                defaultOption={true}
                userId={userId}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <TransactionTypeSelect
                checkedStatus={filterData["resourceType"]}
                setCheckedStatus={(data) => setFilterData({ ...filterData, "resourceType": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <TransactionStatusSelect
                checkedStatus={filterData["status.value"]}
                setCheckedStatus={(data) => setFilterData({ ...filterData, "status.value": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <PaymentTypeSelect
                checkedType={filterData["paymentType"]}
                setCheckedType={(data) => setFilterData({ ...filterData, "paymentType": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
            <StyledSelectGroup>
              <SecondaryTransactionTypeSelect
                checkedType={filterData["transactionType"]}
                setCheckedType={(data) => setFilterData({ ...filterData, "transactionType": data, page: 1 })}
                defaultOption={true}
                direction={direction}
              />
            </StyledSelectGroup>
            <StyledFilterGroup>
              <label htmlFor="relatedReferenceId">
                Related reference Id
              </label>
              <DelayInput
                id="relatedReferenceId"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "relatedReferenceId": event.target.value, page: 1 })}
                name="relatedReferenceId"
                value={filterData["relatedReferenceId"]}
                type="text"
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("transactions.filter.paymentMethods")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock>
            <MappedServicesFilter
              checkedService={filterData["connection.service.name"]}
              setCheckedService={data => handleChangeFilterData(data, "connection.service.name")}

              checkedPaymentSystem={filterData["paymentSystem.name"]}
              setCheckedPaymentSystem={data => handleChangeFilterData(data, "paymentSystem.name")}

              checkedCurrency={filterData["currency.asset"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "currency.asset")}
            />
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("transactions.filter.amount")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock>
            <StyledFilterGroup>
              <label htmlFor="processedAmount[gte]">
                {t("transactions.filter.amountFrom")}
              </label>
              <DelayInput
                id="processedAmount[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "processedAmount[gte]": event.target.value,
                  page: 1
                })}
                name="processedAmount[gte]"
                value={filterData["processedAmount[gte]"]}
                type="number"
                placeholder={t("transactions.filter.example", { value: 1000 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="processedAmount[lte]">
                {t("transactions.filter.amountTo")}
              </label>
              <DelayInput
                id="processedAmount[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({
                  ...filterData,
                  "processedAmount[lte]": event.target.value,
                  page: 1
                })}
                name="processedAmount[lte]"
                value={filterData["processedAmount[lte]"]}
                type="number"
                placeholder={t("transactions.filter.example", { value: 5000 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("transactions.filter.date")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock>
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("transactions.filter.dateFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "createdAt[gte]": getStartOfDayFromDate(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["createdAt[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("transactions.filter.dateTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "createdAt[lte]": getEndOfDayFromDate(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["createdAt[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("transactions.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default TransactionFilter;